import { render } from "./NewInvoicePage.vue?vue&type=template&id=4ea23962&ts=true"
import script from "./NewInvoicePage.vue?vue&type=script&lang=ts"
export * from "./NewInvoicePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__